import { createContext, useContext, useState } from "react";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { useEffect } from "react";

const AVRContext = createContext(null);

export function AVRDrawerProvider({ children }) {
  const [avrId, setAvrId] = useState(null);
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    if (!avrId) return;
    api.get(`/avr/${avrId}`).then(({ data }) => setEntry(data)).catch(() => setEntry(null));
  }, [avrId]);

  return (
    <AVRContext.Provider value={{ openAVR: setAvrId }}>
      {children}
      <Sheet open={!!avrId} onOpenChange={(o) => !o && setAvrId(null)}>
        <SheetContent
          side="right"
          data-testid="avr-drawer"
          className="bg-[var(--oim-surface)] border-[var(--oim-border)] text-[var(--oim-text)] font-body"
        >
          <SheetHeader>
            <SheetTitle className="font-heading text-[var(--oim-text)]">Assumption & Validation Register</SheetTitle>
          </SheetHeader>
          {entry ? (
            <div className="mt-6 space-y-4" data-testid={`avr-row-${entry.avr_id}`}>
              <div className="flex items-center gap-2">
                <span className="font-mono-data text-sm font-semibold">{entry.avr_id}</span>
                <span className="text-[9px] font-heading uppercase tracking-wide px-1.5 py-0.5 rounded-full border"
                  style={{ borderColor: "var(--oim-gold)", color: "var(--oim-gold)" }}>
                  class {entry.avr_class}
                </span>
                {!entry.validated && <span className="text-[10px] text-[var(--oim-gold)]">⚠ unvalidated</span>}
              </div>
              <p className="text-sm text-[var(--oim-text-secondary)]">{entry.description}</p>
              <div>
                <span className="text-[10px] uppercase tracking-widest text-[var(--oim-text-dim)] block mb-1">Drives figures</span>
                <div className="flex flex-wrap gap-1.5">
                  {(entry.linked_figures || []).map((f) => (
                    <span key={f} className="text-[10px] font-mono-data px-1.5 py-0.5 rounded border border-[var(--oim-border)] text-[var(--oim-text-muted)]">{f}</span>
                  ))}
                </div>
              </div>
              {!entry.validated && (
                <div className="text-[11px] leading-relaxed p-3 rounded-md border border-[var(--oim-border)] bg-[var(--oim-surface-soft)] text-[var(--oim-text-muted)]">
                  HIGHEST-SENSITIVITY UNVALIDATED PARAMETER — confirming this value would raise confidence on figures that depend on it.
                </div>
              )}
            </div>
          ) : (
            <div className="mt-6 text-sm text-[var(--oim-text-muted)]" data-testid="avr-drawer-loading">Loading…</div>
          )}
        </SheetContent>
      </Sheet>
    </AVRContext.Provider>
  );
}

export function useAVRDrawer() {
  return useContext(AVRContext);
}
